import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconUpload = createIcon({
  displayName: 'IconUpload',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M11.9991 1.58984L18.7091 8.28984L17.2891 9.70984L11.9991 4.40984L6.70906 9.70984L5.28906 8.28984L11.9991 1.58984ZM20 21V19H4V21H20ZM11 8.24023L12 7.24023L13 8.24023V17.0002H11V8.24023Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
